import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { GridApi } from 'ag-grid-community';

export interface AppliedFilterModel {
  field: string;
  columnHeader: string;
  filter: { [key: string]: any };
}

@Component({
  selector: 'app-grid-applied-filters',
  templateUrl: './grid-applied-filters.component.html',
  styleUrls: ['./grid-applied-filters.component.scss'],
})
export class GridAppliedFiltersComponent implements OnInit, OnChanges, OnDestroy {
  constructor() {}
  @Input() gridApi: GridApi;

  appliedFiltersList: AppliedFilterModel[] = [];
  private boundGridApi: GridApi | null = null;
  private readonly onFilterChange = () => this.updateAppliedFilters();

  ngOnInit() {
    this.bindGridApiEvents();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.gridApi) {
      this.bindGridApiEvents();
    }
  }

  ngOnDestroy(): void {
    this.unbindGridApiEvents();
  }
  removeFilter(filter: AppliedFilterModel): void {
    const filterModel = this.gridApi?.getFilterModel();
    delete filterModel[filter.field];
    this.gridApi.setFilterModel(filterModel);
  }

  /**
   * refresh filterModel into an AppliedFilterModel array
   */
  updateAppliedFilters(): void {
    const filterModel = this.gridApi?.getFilterModel();
    this.appliedFiltersList = [];

    if (filterModel) {
      Object.keys(filterModel).forEach((key) => {
        const filter = filterModel[key];
        const colDef = this.gridApi.getColumnDef(key);
        this.appliedFiltersList.push({
          field: colDef.field,
          columnHeader: colDef.headerName || colDef.field,
          filter: filter,
        });
      });
    }
  }

  removeAllFilters(): void {
    this.gridApi.setFilterModel(null);
  }

  private bindGridApiEvents(): void {
    this.unbindGridApiEvents();

    if (!this.gridApi) {
      this.appliedFiltersList = [];
      return;
    }

    this.boundGridApi = this.gridApi;
    this.boundGridApi.addEventListener('filterChanged', this.onFilterChange);
    this.boundGridApi.addEventListener('gridColumnsChanged', this.onFilterChange);
    this.updateAppliedFilters();
  }

  private unbindGridApiEvents(): void {
    if (!this.boundGridApi) {
      return;
    }

    this.boundGridApi.removeEventListener('filterChanged', this.onFilterChange);
    this.boundGridApi.removeEventListener('gridColumnsChanged', this.onFilterChange);
    this.boundGridApi = null;
  }
}
